import App from './app';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.sass';
import { loadableReady } from '@loadable/component';

if (process.env.APP_ENV === 'development') {
	createRoot(document.getElementById('root') as any).render(<App />);
} else {
	loadableReady(() => {
		hydrateRoot(document.getElementById('root') as any, <App />);
	});
}
